module.exports = {
    log_in: "Prihlásiť sa",
    language_select: "Jazyk"
}